import axios from 'axios'
import UpdateAccount from './dto/UpdateAccount'
import GetAccount from './dto/GetAccount'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_GET = `${API_URL}/Profile/GetUserDetail`
export const URL_UPDATE = `${API_URL}/Profile/UpdateUserDetail`

export function onGetAccount(): Promise<GetAccount> {
  return axios.get(URL_GET)
}

export function onUpdateAccount(updateAccountInput: UpdateAccount): Promise<boolean> {
  return axios.put(URL_UPDATE, updateAccountInput)
}
